/**
 * No operation.
 */
export function noop() {
  // Does nothing
}

export default noop;
